export const baseUrl = "https://game-maker-api.staging.imigames.io";
